<!-- <app-sku-item-stock-grid></app-sku-item-stock-grid> -->

<ng-container *ngIf="_routeName !== 'forecasting'">
  <div class="input-container">
    <div class="input-container_label">FBA Type:</div>
    <select
      class="input-container_input input-container_input--thin"
      (change)="updateFbaType()"
      [formControl]="shipmentType"
    >
      <option *ngFor="let type of fbaTypes" [value]="type.id">{{type.name}}</option>
    </select>
  </div>
  <div class="section">
    <div class="section_title">Suggestion Breakdown</div>
    <div class="section_content">
  
      <div class="list">
        <div class="list_item list_item--buffer">
  
          <div class="list_title">Demand ({{selectedSku?.replenishVelocity | number: "1.0-2"}} * {{selectedSku?.replenishDays | number: "1.0-2"}})</div>
          <div class="list_total">{{ totalStock | number: "1.0-0"}}
          </div>
        </div>
  
        <div class="list_item list_item--buffer" *ngIf="showSeasonalVelocity && selectedSku?.velocity90_1yr">
          <div class="list_title">Seasonal velocity</div>
          <div class="list_total">{{selectedSku?.amountDiffRepl | number: "1.0-0"}} </div>
        </div>
  
        <div class="list_item list_item--buffer">
          <div class="list_title"> Channel stock</div>
          <div class="list_total">-{{(selectedSku?.fbaStock || 0)}} </div>
        </div>
  
        <div class="list_item list_item--buffer">
          <div class="list_title">In shipment</div>
          <div class="list_total">-{{(selectedSku?.amountInShipment + selectedSku?.working) || 0 }} </div>
        </div>
        <div class="list_item list_item--buffer">
          <div class="list_title">Case Rounding</div>
          <div class="list_total">{{roundedAmount || 0 }} </div>
        </div>
  
  
        <div class="list_item  section_summary">
          <div class="list_title"> Total Suggested: <span>{{suggestedAmount | number: "1.0-2" }}</span></div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="sku-panel_devider"></div>
</ng-container>


<div *ngIf="_routeName == 'forecasting'">
  <app-sku-mapping
    [mappings]="mappings"
    [financeData]="financeData"
    [isFinanceData]="true"
  ></app-sku-mapping>
</div>
<div class="sku-panel_devider"></div>

<div *ngIf="isPlanyard != null">
  <app-sku-mapping
    [mappings]="mappings"
    (viewEvent)="editMapping()"
  ></app-sku-mapping>
</div>

<div class="sku-panel_devider"></div>

<app-sku-fba-history-grid [asin]="selectedSku.asin" [firstStockDate]="selectedSku.firstStockDate" [account]="selectedSku.account"  [stockType]="selectedSku.fulfillmentType"></app-sku-fba-history-grid>

<div class="sku-panel_devider"></div>
<div class="mini-grid" *ngIf="_routeName !== 'forecasting'">
  <div class="mini-grid_title">FBA Shipment</div>
    <ag-grid-angular
      style="width: 100%; height: 300px"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"
      [headerHeight]="30"
    ></ag-grid-angular> 
</div>

<!-- 
<mat-tab-group mat-align-tabs="start">
  <mat-tab>
    <app-sku-fba-history-grid [sku]="selectedSku"></app-sku-fba-history-grid>
  </mat-tab>
  <mat-tab>
    <app-sku-mapping
      [mappings]="mappings"
      (viewEvent)="editMapping()"
    ></app-sku-mapping>
  </mat-tab>
</mat-tab-group> -->
